import { render, staticRenderFns } from "./CardTarjaRadarCopa.vue?vue&type=template&id=e6d880b6&scoped=true"
import script from "./CardTarjaRadarCopa.vue?vue&type=script&lang=js"
export * from "./CardTarjaRadarCopa.vue?vue&type=script&lang=js"
import style0 from "./CardTarjaRadarCopa.vue?vue&type=style&index=0&id=e6d880b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6d880b6",
  null
  
)

export default component.exports